import React, { Component } from 'react';

import FieldModal from '../../../components/modals/fieldModal';

class DeleteProposalRequestsModal extends Component {
	state = {
		submitting: false
	};

	handleDelete = () => {
		if (this.state.submitting) return;
		this.setState({ submitting: true });
		this.props.delete();
	};

	render() {
		const { isOpen, count, toggle } = this.props;
		const { submitting } = this.state;
		return (
			<FieldModal
				size="small"
				isOpen={isOpen}
				modalTitle={`Delete ${count > 1 ? 'Proposal Requests' : 'Proposal Request'}`}
				bodyHeaderText={
					<span>
						You are about to delete{' '}
						<b>
							{count} {count > 1 ? 'proposal requests' : 'proposal request'}
						</b>
						, this is irreversible, would you like to continue?
					</span>
				}
				bodyContent={() => ''}
				toggle={toggle}
				actionButtonLabel={!submitting ? 'Delete' : 'Deleting...'}
				actionButton={this.handleDelete}
				actionButtonDisabled={submitting}
				isDelete={true}
			/>
		);
	}
}

export default DeleteProposalRequestsModal;
